import React, { useState } from 'react';
import styled from 'styled-components';
import IconButton from '@material-ui/core/IconButton';
import BookmarkIcon from '@material-ui/icons/BookmarkBorder';
import BookmarksModal from '../modals/bookmarks/BookmarksModal';

const RootContainer = styled.div`
  flex: 0 0 auto;
`;

const BookmarksButton = () => {
  const [bookmarksModalOpen, setBookmarksModalOpen] = useState(false);

  const openBookmarks = () => {
    setBookmarksModalOpen(true);
  };

  const closeBookmarks = () => {
    setBookmarksModalOpen(false);
  };

  return (
    <RootContainer>
      <IconButton color="inherit" aria-label="bookmarks" onClick={openBookmarks}>
        <BookmarkIcon />
      </IconButton>
      <BookmarksModal open={bookmarksModalOpen} onClose={closeBookmarks} />
    </RootContainer>
  );
};

export default BookmarksButton;
